import withDraft from '@/utils/draftHelper';
import actions from '@/datasets/constants';
import { updateAuditName } from './state';

const updateDatasetName = withDraft((draft, { code, result: { catalogue: { title } } }) => {
  updateAuditName(draft, 'dataset', code, title);
});

export default {
  [actions.UPDATE_DATASET_CATALOGUE_SUCCESS]: updateDatasetName,
  [actions.UPDATE_DATASET_SUCCESS]: updateDatasetName,
};
